import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import OnboardingNavigation from './OnboardingNavigation';

const OnboardingNavigationPicker = ({ clientResource, ...rest }) => {
  return pickFunction(clientResource, {
    [fr.relationships.onboardingNavigation.name]: () => {
      return (
        <OnboardingNavigation
          clientResource={clientResource}
          {...rest}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default OnboardingNavigationPicker;
